module.exports = __webpack_public_path__ + "files/315df0b6f08fd2ef5e3fa5ca3637c049.svg";